import { Modal, Typography } from 'antd';

import { Button } from '@shared/components';

const { Text } = Typography;

const MyInfoRetrievalErrorModal = () => {
  const onClose = () => {
    Modal.destroyAll();
  };

  return (
    <div className="flex flex-col items-center">
      <Text className="mb-2 text-base font-bold">Retrieval Error</Text>
      <Text className="mb-4 text-center text-sm">
        An error occured while retrieving your Myinfo profile. Please try again.
      </Text>

      <Text className="mb-4 text-center text-sm">
        Should this error persists, do contact us for further investigation.
      </Text>
      <Button block onClick={onClose}>
        Close
      </Button>
    </div>
  );
};

export default MyInfoRetrievalErrorModal;
